import { render, staticRenderFns } from "./RequestView.vue?vue&type=template&id=f92ac1e6&"
import script from "./RequestView.vue?vue&type=script&lang=js&"
export * from "./RequestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports